import { api } from "./client";
import type { Transaction, PaginatedResponse, FinancialSummary } from "./types";

export interface TransactionFilters {
  startDate?: string;
  endDate?: string;
  patientId?: string;
  status?: string;
  paymentMethod?: string;
  page?: number;
  limit?: number;
}

export interface CreateTransactionData {
  patientId: string;
  appointmentId?: string;
  procedureId: string;
  amount: number;
  discount?: number;
  paymentMethod: "CASH" | "CREDIT_CARD" | "DEBIT_CARD" | "PIX" | "BANK_TRANSFER" | "HEALTH_INSURANCE";
  notes?: string;
}

export const transactionsService = {
  async list(filters?: TransactionFilters): Promise<PaginatedResponse<Transaction>> {
    return api.get<PaginatedResponse<Transaction>>("/transactions", filters);
  },

  async getSummary(filters?: { startDate?: string; endDate?: string }): Promise<FinancialSummary> {
    return api.get<FinancialSummary>("/transactions/summary", filters);
  },

  async getById(id: string): Promise<Transaction> {
    return api.get<Transaction>(`/transactions/${id}`);
  },

  async create(data: CreateTransactionData): Promise<Transaction> {
    return api.post<Transaction>("/transactions", data);
  },

  async updateStatus(id: string, status: string): Promise<Transaction> {
    return api.patch<Transaction>(`/transactions/${id}/status`, { status });
  },
};
